export default __webpack_public_path__ + "static/The Home_Image 5_carousel 7@2x-157b094434349f67109404078512d90e.jpg";